import React, { useCallback } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { AnalyticsInstance } from '@ts/utils/analytics';
import ExitCheckoutPrompt from '@ts/components/Checkout/ExitCheckoutPrompt';
import CircleIconButton from '@ts/ui/CircleIconButton';
import Logotype from '@ts/ui/Logotype';
import routes from '@ts/containers/App/routes';
import { ReactComponent as IconMenu } from '@ts/images/icons/icon_menu.svg';
import LabeledLink from './LabeledLink';
import ContactPhone from './ContactPhone';
import * as S from './styles';

const ExitCheckoutPromptPopup = ({ visible, close }) =>
    visible && <ExitCheckoutPrompt close={close} />;

function Navbar({
    cartItems,
    wishList,
    forceSimplify,
    match,
    checkoutPosition,
    openNavigation,
    transparent,
}) {
    const countCartItems = cartItems.length;
    const cartIsEmpty = countCartItems <= 0;
    const countWishItems = wishList.length;
    const wishIsEmpty = countWishItems <= 0;

    const [checkoutPrompt, setCheckoutPrompt] = React.useState(false);
    const open = useCallback(() => setCheckoutPrompt(true), []);
    const close = useCallback(() => setCheckoutPrompt(false), []);

    const clickLogotype = useCallback(
        (evt) => {
            AnalyticsInstance.navigation.clickedLogotype();
            if (match.path === routes.checkoutPage && checkoutPosition < 2) {
                evt.preventDefault();
                open(true);
            }
        },
        [match.path, open, checkoutPosition]
    );

    const clickWishButton = () => AnalyticsInstance.navigation.clickedWishButton();

    const clickCartButton = useCallback(
        (evt) => {
            if (!cartIsEmpty) {
                AnalyticsInstance.navigation.clickedCartButton();
            } else {
                evt.preventDefault();
            }
        },
        [cartIsEmpty]
    );

    const isAvailText = match.path === routes.checkoutPage || match.path === routes.cartPage;

    return (
        <S.Navbar data-test-id="navbar" className="header__navBar">
            <ExitCheckoutPromptPopup close={close} visible={checkoutPrompt} />
            <S.Wrapper>
                <S.IconMenuWrapper onClick={openNavigation}>
                    <IconMenu />
                </S.IconMenuWrapper>
                <S.BrandLink
                    transparent={String(transparent)}
                    onClick={clickLogotype}
                    data-test-id="brand-link"
                    title="TripShock!"
                    to="/"
                >
                    <Logotype />
                </S.BrandLink>
                <S.Actions data-test-id="actions" className="actions">
                    <React.Fragment>
                        {!forceSimplify && (
                            <React.Fragment>
                                <CircleIconButton
                                    as={LabeledLink}
                                    to="/wishlist/"
                                    icon="heart"
                                    inverted={wishIsEmpty ? 0 : 1}
                                    label={wishIsEmpty ? undefined : countWishItems}
                                    data-test-id="wish-button"
                                    title="Wish List"
                                    onClick={clickWishButton}
                                />
                                <CircleIconButton
                                    as={LabeledLink}
                                    to="/cart/"
                                    icon="cart"
                                    inverted={cartIsEmpty ? 0 : 1}
                                    label={cartIsEmpty ? undefined : countCartItems}
                                    data-test-id="cart-button"
                                    title="Cart"
                                    onClick={clickCartButton}
                                />
                            </React.Fragment>
                        )}
                    </React.Fragment>
                    <React.Fragment>
                        {forceSimplify && <ContactPhone isAvailText={isAvailText} />}
                    </React.Fragment>
                </S.Actions>
            </S.Wrapper>
        </S.Navbar>
    );
}

export default compose(React.memo, withRouter)(Navbar);
